/**
 * Dashboard Layout Hook
 * ウィジェットのドラッグ&ドロップレイアウト管理
 */

import { useState, useCallback } from 'react';
import type { Layout } from 'react-grid-layout';

const DEFAULT_LAYOUT: Layout[] = [
  { i: 'kpi', x: 0, y: 0, w: 12, h: 5, minW: 12, minH: 4, maxH: 8 },
  { i: 'checkin', x: 0, y: 5, w: 4, h: 10, minW: 3, minH: 8 },
  { i: 'weekly', x: 4, y: 5, w: 4, h: 10, minW: 3, minH: 8 },
  { i: 'trend', x: 8, y: 5, w: 4, h: 10, minW: 3, minH: 8 },
  { i: 'insights', x: 0, y: 15, w: 6, h: 8, minW: 4, minH: 6 },
  { i: 'schedule', x: 6, y: 15, w: 6, h: 8, minW: 4, minH: 6 },
];

export const useDashboardLayout = () => {
  const [layout, setLayout] = useState<Layout[]>(() => {
    try {
      const saved = localStorage.getItem('dashboard_layout');
      if (saved) {
        const parsedLayout = JSON.parse(saved);
        // 保存されたレイアウトのアイテム数が正しいか確認
        if (parsedLayout.length === DEFAULT_LAYOUT.length) {
          return parsedLayout;
        }
      }
    } catch (error) {
      console.error('Failed to load saved layout:', error);
    }
    // デフォルトレイアウトを返す
    return DEFAULT_LAYOUT;
  });

  const [isEditMode, setIsEditMode] = useState(false);

  const onLayoutChange = useCallback((newLayout: Layout[]) => {
    setLayout(newLayout);
    localStorage.setItem('dashboard_layout', JSON.stringify(newLayout));
  }, []);

  const resetLayout = useCallback(() => {
    setLayout(DEFAULT_LAYOUT);
    localStorage.setItem('dashboard_layout', JSON.stringify(DEFAULT_LAYOUT));
    // 強制的にページをリロード（確実にデフォルトに戻す）
    window.location.reload();
  }, []);

  return { layout, onLayoutChange, isEditMode, setIsEditMode, resetLayout };
};
